
$("document").ready(function() {  
  var video = document.getElementById("meta_video_v");
  video.play();  
   // video.WebKitPlaysInline = true;
   //    video.autoplay = "autoplay";

});

$("document").ready(function() {  
  if ($(".product__thumb-item").hasClass("video-show-first")) {   
    $('.product__thumb-item.video-show-first span.product__thumb-icon_custom').trigger('click');
    }
  else{
    $('.product__thumb-item .product__thumb-icon').trigger('click');
  }
  console.log("testing");
    $('.custom-video_class').removeAttr('onclick');
  $(".custom-video_class").get(0).play();
  $(".custom-video_class").attr('loop','loop' );
  $('.custom-video_class').attr("autoplay"," ");
  $('.custom-video_class').attr('controls',false);
  $('.custom-video_class').attr('preload','none');
  $('.custom-video_class').attr('muted',true);
    $('.video-c-custom').attr('data-video-style','muted');

   $(".product__video-wrapper").click(function(e){
    e.preventDefault()
    e.stopPropagation()
  }); 
  
   $(".video-c-main").click(function(e){
    e.preventDefault()
    e.stopPropagation()
  }); 
   $(".video-c-custom").click(function(e){
    e.preventDefault()
    e.stopPropagation()
  }); 
 
   
});
 $(".mobile-nav__link-custom").click(function(e){
    e.preventDefault()
    e.stopPropagation()
      // $(this).parents(".mobile-nav__item").find(".mobile-nav__sublist").toggleClass("is-open");
    $(this).siblings(".mobile-nav__toggle").find(".collapsible-trigger").trigger("click");
   console.log("test");
  }); 
 $(".mobile-nav__link-subcustom").click(function(e){
    e.preventDefault()
    e.stopPropagation()
      // $(this).parents(".mobile-nav__item").find(".mobile-nav__sublist").toggleClass("is-open");
    $(this).siblings(".collapsible-trigger").trigger("click");
   console.log("test1");
  }); 
 
 $('.product-block--price, afterpay-placement, .right-div-discount, .discount_feature-ontainer, #shopify-block-loox-rating, .product-3d-model').wrapAll('<div class="product-block-custom-price-main">');
  
 var disc = $("span.discount-cde-bt-hr").text().replace("%","");


  var currency_format = $("html").attr("symbol");
var ret = currency_format.replace("{{amount}}",'');
 
 $(document).on('change', 'select.pplr_select', function() { 
  var pricem = $("select.variant-selection__variants").find("option:selected").attr("price");
   var pricem1 = pricem.replace(ret,"");
  pricem1 = pricem1.replace(",","");
  // Does some stuff and logs the event to the console
  console.log(pricem)
  //var val = $(this).find("option:selected").attr("data-price");
   var val = $(this).find("option:selected").attr('data-pplr_price');
  var add = parseFloat(pricem1) + parseInt(val);
  var per = (parseInt(disc)/parseInt(100))*add;
  per = per.toFixed(2);
  console.log(per);
  var per1 = parseFloat(add) - parseFloat(per);
  per1 = per1.toFixed(2);
     // format number to Indian rupee
let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
});
per1 =  rupee.format(per1);
per1 = per1.replace("₹","");
  console.log(per1);
  $(".right-div").text(ret+per1);
  
  add = add.toFixed(2);
  console.log(add);
  $("span.price span.money").text(ret+add);
  $("span.compricew-bt").text(ret+add);
  //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');
  $(".right-div-discount").text(ret+per1);
  $(".right-div-vendors").text(ret+add);
  
});



$("document").ready(function() {    
  $(".variant-selection").on("change", function(){

  var hre = location.search;
  var atr = hre.replace("?variant=","");
  //var atr = $(this).attr("variant");
  var disc = $("span.discount-cde-bt-hr").text().replace("%","");
  console.log(atr);
 
  if(atr =="unavailable")
  {
   $(".right-div-discount").text("");
  }
 
  $("span.custo-var .v--list").each(function(){
    var id = $(this).attr("id");
    if ( id == atr )
    {
      var get = $(this).attr("v-price");
      get = get.replace(ret,"");
      get = get.replace(",","");
      var len = $("select.pplr_select").length;
      if ( len > 0 )
      {
        //var findp = $("select.pplr_select").find("option:selected").attr('data-price');
          var findp = $("select.pplr_select").find("option:selected").attr('data-pplr_price');
        
      var newp = parseFloat(get) + parseInt(findp);
      console.log(get);
      console.log(findp);
      newp = newp.toFixed(2);
      console.log(newp);
      $("span.compricew-bt").text(ret+newp);
        $(".right-div-vendors").text(ret+newp);
      $(" .modal_price.subtitle .price-ui span.price span.money").text(ret+newp);
      }
      else
      {
        $("span.compricew-bt").text(ret+get);
        $(".right-div-vendors").text(ret+get);
      $(" .modal_price.subtitle .price-ui span.price span.money").text(ret+get);
      }
      price = get.replace(ret, "");
      console.log(price);
      price = price.replace(",","");
      var per = (disc/100)*price;
      per = per.toFixed(2);
      var per1 = parseFloat(price) - parseFloat(per);
      per1 = per1.toFixed(2);
  // format number to Indian rupee
let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
});
per1 =  rupee.format(per1);
per1 = per1.replace("₹","");
      $(".right-div").text(ret+per1);
      //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');
      $(".right-div-discount").text(ret+per1);
      
      // $(".right-div-vendors").text("$"+price);
    }  
  })
   var width = $(window).width();
          if(width < 798 )
          {
             //$("html,body").animate({scrollTop:0},'smooth');
            $('html, body').animate({
                scrollTop: $("#product-gallery-custom").offset().top 
            }, 'smooth');
          } 
})
   var atr = $("select.variant-selection__variants").find("option:selected").attr("value");
  //monogram variable for selected_variant
 // var atr = $("variant-selection").attr("variant");
  var disc = $("span.discount-cde-bt-hr").text().replace("%","");
  console.log(atr);
  
  $("span.custo-var .v--list").each(function(){
    var id = $(this).attr("id");
    if ( id == atr )
    {
      var get = $(this).attr("v-price");
      var gett = $(this).attr("v-price");
      price = get.replace(ret, "");
      get = get.replace(ret,"");
      //var findp = $("select.pplr_select").find("option:selected").attr('data-price');
      var findp = $("select.pplr_select").find("option:selected").attr('data-pplr_price');
      var newp = parseFloat(get) + parseInt(findp);
      newp = newp.toFixed(2);
      $("span.compricew-bt").text(gett);
      $(".right-div-vendors").text(gett);
      //$(" .modal_price.subtitle .price-ui span.price span.money").text("$"+newp);
      //$("span.compricew-bt").text(get
      price = price.replace(",","");
      var per = (disc/100)*price;
      per = per.toFixed(2);
      console.log(per);
      console.log(price);
      var per1 = parseFloat(price) - parseFloat(per);
      per1 = per1.toFixed(2);
  // format number to Indian rupee
let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
});
per1 =  rupee.format(per1);
per1 = per1.replace("₹","");
      console.log(per1);
      $(".right-div").text(ret+per1);
      //$(this).parents(".product-form-container").parents(".product_section").find(".product-block--price").addClass('enable_discount-cls');
      $(".right-div-discount").text(ret+per1);
      //$(".right-div-vendors").text("$"+price);
    }
  })
  // $("select.pplr_select").on("change", function(e){ 
  //   e.preventDefault();
  //   e.stopPropagation();
  //   console.log("selected");
  //   var val = $(this).find("option:selected").attr("data-price");
  //   console.log(val);
  //   var pricem = $("span.price span.money").text();
  //   pricem = pricem.replace("$","");
  //   var add = parseFloat(pricem) + parseInt(val);
  //   $("span.price span.money").text("$"+add);
  //   var per = (disc/100)*pricem;
  //     per = per.toFixed(2);
  //     var per1 = parseFloat(pricem) - parseFloat(per);
  //     per1 = per1.toFixed(2);
  //     $(".right-div").text("$"+per1);
                 
  // })
});

$(document).ready(checkContainerr);
function checkContainerr() {
  if($('.product-personalizer button').is(':visible')){ //if the container is visible on the page
     $(".purchase-details").hide();
   // $(".right-div-discount").hide();
   // $(".product-block--price").removeClass("enable_discount-clss");
     
    }
  else {
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    $(".purchase-details").show(); 
   //  $(".right-div-discount").show();
  }
}
 


